import { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { LatestContentItem } from '../features/content/types';

export const useContentModal = (allContent: LatestContentItem[] = []) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedContent, setSelectedContent] = useState<LatestContentItem | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { contentId } = useParams<{ contentId: string }>();

  // Check if we're on a content modal route
  const isContentRoute = location.pathname.includes('/discover/') && contentId;

  useEffect(() => {
    if (isContentRoute && contentId && allContent.length > 0) {
      // Find the content by ID
      const content = allContent.find(item => item.id === contentId);
      if (content) {
        setSelectedContent(content);
        setIsModalOpen(true);
      } else {
        // Content not found, redirect back to discover
        navigate('/discover', { replace: true });
      }
    } else if (!isContentRoute && isModalOpen) {
      // URL changed away from content route, close modal
      setIsModalOpen(false);
      setSelectedContent(null);
    }
  }, [contentId, isContentRoute, allContent, isModalOpen, navigate]);

  const openModal = (content: LatestContentItem) => {
    setSelectedContent(content);
    setIsModalOpen(true);
    // Update URL without causing a page reload
    navigate(`/discover/${content.id}`, { replace: false });
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedContent(null);
    // Use browser back to return to previous page
    navigate(-1);
  };

  return {
    isModalOpen,
    selectedContent,
    openModal,
    closeModal
  };
}; 